/*
 * @Author: ligang
 * @Date: 2024-11-12 10:54:07
 * @Description:
 */
// 验证手机号
export const validatorPhoneNumber = (_rule: any, value: any, callback: any) => {
  const reg = /(1[3|4|5|7|8]\d{9})(((\D{1}|$)[\s\S]*)+)/g;
  if (!value || !reg.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
};

/**
 * @description: 手机号校验（弱检验，只判断第一位是 1，且必须是数字，并且是11位）
 * @param {any} _rule
 * @param {any} value
 * @param {any} callback
 * @returns {*}
 */
export const validatorPhone = (_rule: any, value: any, callback: any) => {
  const reg = /^1\d{10}$/;
  if (!value || !reg.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
};

/**
 * @description: 验证手机号码
 * @param {any} rule
 * @param {string} value
 * @param {any} callback
 * @returns {*}
 */
export const validatorPassword = (
  rule,
  value,
  callback: (error?: string | Error) => void,
  source,
  options,
  msg?
) => {
  if (!value) return callback(new Error(msg || '请输入正确的密码'));

  const regex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d])[^\u4e00-\u9fa5\s]{8}$/;
  if (!regex.test(value) || value.length !== 8) {
    return callback(new Error('密码必须包含数字、字母以及特殊符号'));
  } else {
    return callback();
  }
};

/**
 * @description: 只允许输入汉字、英文字母、数字、_、·、()、（）
 * @param {any} rule
 * @param {string} value
 * @param {any} callback
 * @returns {*}
 */
export const validatorContent = (
  rule,
  value,
  callback: (error?: string | Error) => void,
  source,
  options,
  msg?
) => {
  if (!value) return callback(new Error(msg || '请输入内容'));

  const regex = /^[\u4e00-\u9fffA-Za-z0-9_\u00B7()（）]+$/;
  if (!regex.test(value)) {
    return callback(new Error('请输入汉字、英文字母、数字、_、·、()、（）'));
  } else {
    return callback();
  }
};
export const validatorEmail = (_rule: any, value: string, callback: any) => {
  if (!value?.length) return callback(new Error('请输入邮箱地址'));
  if (!/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.(com|net)$/.test(value)) {
    return callback(new Error('请输入字母、数字、_+域名.com、.net'));
  }
  callback();
};
